import React, { Component } from 'react';

import './EntityValue.css';

class EntityValue extends Component {
  
  static defaultProps = {
    value : "UNDEFINED",
  }

  state = { 

  }
  render() { 

    const { value } = this.props;

    return ( 
      <p className="entity-value" > 
        {value}
      </p>
    );
  }
}
 
export default EntityValue;